import React, { useRef, useEffect, useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import axios from 'axios';
import default_img from '../../../../../images/product/productcategory.png';
import img from '../../../../../images/apf_small_logo.png';
import Select from "react-select";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify'; 

const EditProdcat = ({ show, onClose, id, onUpdated }) => { 
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [initialImage, setInitialImage] = useState(null);
    const [selectedSchedule, setSelectedSchedule] = useState(null);
    const [scheduleOptions, setScheduleOptions] = useState([]);
    const imageInputRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const capitalizeWords = (str) => str.replace(/\b\w/g, char => char.toUpperCase());
    const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    useEffect(() => {
        if (!show) resetForm();
    }, [show]);

    const resetForm = () => {
        setFile(null);
        setPreviewUrl(null);
        setName('');
        setDescription('');
        setInitialImage(null);
        setSelectedSchedule(null);
        setErrors({});
    };

    useEffect(() => {
        const fetchSchedules = async () => {
            try {
                const res = await axios.get(`${baseURL}/item-schedule/items/active`);
                if (res.status === 200 && res.data.data) {
                    const options = res.data.data.map(item => ({
                        value: item.sno,
                        label: item.itemschedule_name,
                    }));
                    setScheduleOptions(options);
                }
            } catch (err) {
                console.error('Error fetching schedules:', err);
            }
        };
        fetchSchedules();
    }, [baseURL]);

    useEffect(() => {
        if (show && id && scheduleOptions.length > 0) {
            setLoading(true);
            axios.get(`${baseURL}/product-categories/${id}`)
                .then(res => {
                    const data = res.data?.data;
                    if (data) {
                        setName(data.productcategory_name || '');
                        setDescription(data.description || '');
                        setInitialImage(
                            data.productcategory_img?.startsWith('http')
                                ? data.productcategory_img
                                : `${baseURL}/productcategory_images/${data.productcategory_img}`
                        );

                        // setInitialImage(data.productcategory_img ? `${baseURL}/productcategory_images/${data.productcategory_img}` : null);
                        setFile(null);
                        setPreviewUrl(null);
                        const matched = scheduleOptions.find(opt => opt.value === data.schedule);
                        setSelectedSchedule(matched || null);
                    }
                })
                .catch(err => {
                    console.error('Fetch error:', err);
                    alert("Failed to load product category.");
                })
                .finally(() => setLoading(false));
        }
    }, [show, id, scheduleOptions]);

    const fileHandler = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
        const maxSizeKB = 50;

        if (!validTypes.includes(selectedFile.type)) {
            setErrors(prev => ({ ...prev, file: 'Only .jpeg, .png, .jpg, .gif formats are allowed.' }));
            setFile(null);
            setPreviewUrl(null);
            return;
        }

        if (selectedFile.size / 1024 > maxSizeKB) {
            setErrors(prev => ({ ...prev, file: 'Image size must be under 50KB.' }));
            setFile(null);
            setPreviewUrl(null);
            return;
        }

        if (previewUrl) URL.revokeObjectURL(previewUrl);
        setFile(selectedFile);
        setPreviewUrl(URL.createObjectURL(selectedFile));
        setErrors(prev => ({ ...prev, file: null }));
    };

    const RemoveImage = () => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        setFile(null);
        setPreviewUrl(null);
        setErrors(prev => ({ ...prev, file: null }));
        if (imageInputRef.current) imageInputRef.current.value = '';
    };

    const handleNameChange = (e) => {
        const value = capitalizeWords(e.target.value.toLowerCase());
        setName(value);
        setErrors(prev => ({ ...prev, productCategoryName: null }));
    };

    const handleDescriptionChange = (e) => {
        const value = capitalizeFirstLetter(e.target.value.trimStart());
        setDescription(value);
    };

    // const handleUpdate = async () => {
    //     const newErrors = {};

    //     if (!name.trim()) newErrors.productCategoryName = 'Product Category Name is required.';
    //     else if (name.length > 25) newErrors.productCategoryName = 'Product Category Name cannot exceed 25 characters.';

    //     if (description && description.length > 100)
    //         newErrors.description = 'Description cannot exceed 100 characters.';

    //     if (!selectedSchedule) newErrors.schedule = 'Schedule selection is required.';

    //     setErrors(newErrors);
    //     if (Object.keys(newErrors).length > 0) return;

    //     const formData = new FormData();
    //     formData.append('productcategory_name', name);
    //     formData.append('description', description);
    //     formData.append('schedule', selectedSchedule.value);
    //     if (file) formData.append('productcategory_img', file);

    //     try {
    //         await axios.post(`${baseURL}/product-categories/${id}`, formData, {
    //             headers: { 'Content-Type': 'multipart/form-data' }
    //         });
    //         onUpdated();
    //         onClose(); 
    //         toast.success("Product Category updated successfully!");
    //     } catch (error) {
    //         if (error.response && error.response.status === 400) {
    //             const serverErrors = error.response.data.errors;
    //             const newServerErrors = {};
    //             if (serverErrors.productcategory_name)
    //                 newServerErrors.productCategoryName = serverErrors.productcategory_name[0];
    //             if (serverErrors.description)
    //                 newServerErrors.description = serverErrors.description[0];
    //             if (serverErrors.schedule)
    //                 newServerErrors.schedule = serverErrors.schedule[0];
    //             if (serverErrors.productcategory_img)
    //                 newServerErrors.file = serverErrors.productcategory_img[0];

    //             setErrors(newServerErrors);
    //         } else {
    //             console.error('Update failed:', error);
    //             toast.error("Failed to create product category.");
    //         }
    //     }
    // };

    const handleUpdate = async () => {
        const newErrors = {};

        // 🧩 Basic validations
        if (!name.trim()) newErrors.productCategoryName = 'Product Category Name is required.';
        else if (name.length > 25) newErrors.productCategoryName = 'Product Category Name cannot exceed 25 characters.';

        if (description && description.length > 100)
            newErrors.description = 'Description cannot exceed 100 characters.';

        if (!selectedSchedule)
            newErrors.schedule = 'Schedule selection is required.';

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        // 🧠 Get user and branch info from localStorage
        const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
        const user_id = parseInt(localStorage.getItem("user_id"), 10);

        // 🗂️ Prepare form data
        const formData = new FormData();
        formData.append('productcategory_name', name);
        formData.append('description', description);
        formData.append('schedule', selectedSchedule.value);
        if (file) formData.append('productcategory_img', file);

        // ✅ Add branch and updater info
        if (!isNaN(branch_id)) formData.append('branch_id', branch_id);
        if (!isNaN(user_id)) formData.append('updated_by', user_id);

        try {
            const response = await axios.post(`${baseURL}/product-categories/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (response.status === 200) {
                onUpdated();
                onClose();
                toast.success("Product Category updated successfully!");
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                const serverErrors = error.response.data.errors;
                const newServerErrors = {};
                if (serverErrors.productcategory_name)
                    newServerErrors.productCategoryName = serverErrors.productcategory_name[0];
                if (serverErrors.description)
                    newServerErrors.description = serverErrors.description[0];
                if (serverErrors.schedule)
                    newServerErrors.schedule = serverErrors.schedule[0];
                if (serverErrors.productcategory_img)
                    newServerErrors.file = serverErrors.productcategory_img[0];

                setErrors(newServerErrors);
            } else {
                console.error('Update failed:', error);
                toast.error("Failed to update product category.");
            }
        }
    };

    return (
        <Modal show={show} onHide={onClose} size="md" backdrop="static">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Product Category</h3>
                    <Button variant="" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    {loading ? (
                        <div className="text-center py-5">  <img src={img} alt="Loading..." style={{ width: '50px', height: '40px' }} />Loading...</div>
                    ) : (
                        <>
                            {/* <div className="mb-2">
                                <label className="text-black font-w500 fs-7">Product Category <span className="required">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={name}
                                    onChange={handleNameChange}
                                />
                                {errors.productCategoryName && (
                                    <div className="text-danger mt-1 fs-8">{errors.productCategoryName}</div>
                                )}
                            </div> */}

                            <div className="mb-2">
                                <label className="text-black font-w500 fs-7">
                                    Product Category <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={name}
                                    maxLength={25}
                                    onChange={(e) => {
                                        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                        handleNameChange({ target: { value: onlyLetters } });
                                    }}
                                />
                                {errors.productCategoryName && (
                                    <div className="text-danger mt-1 fs-8">{errors.productCategoryName}</div>
                                )}
                            </div>


                            <div className="mb-2">
                                <label className="text-black font-w500 fs-7">Schedule <span className="required">*</span></label>
                                <Select
                                    placeholder="Select Schedule"
                                    options={scheduleOptions}
                                    value={selectedSchedule}
                                    onChange={(opt) => {
                                        setSelectedSchedule(opt);
                                        setErrors(prev => ({ ...prev, schedule: null }));
                                    }}
                                />
                                {errors.schedule && (
                                    <div className="text-danger mt-1 fs-8">{errors.schedule}</div>
                                )}
                            </div>

                            {/* <div className="mb-2">
                                <label className="text-black font-w500 fs-7">Description</label>
                                <textarea
                                    rows={4}
                                    className="form-control"
                                    value={description}
                                    onChange={handleDescriptionChange}
                                    placeholder="Description"
                                />
                                {errors.description && (
                                    <div className="text-danger mt-1 fs-8">{errors.description}</div>
                                )}
                            </div> */}

                            <div className="mb-2">
                                <label className="text-black font-w500 fs-7">Description</label>
                                <textarea
                                    rows={4}
                                    className="form-control"
                                    value={description}
                                    onChange={handleDescriptionChange}
                                    placeholder="Description"
                                    maxLength={100}
                                />
                                {errors.description && (
                                    <div className="text-danger mt-1 fs-8">{errors.description}</div>
                                )}
                            </div>



                            <div className="mb-2">
                                <label className="text-black font-w500 fs-7 d-block">Product Category Image</label>
                                <span className='fs-8 text-gray-800'>Size: </span>
                                <span className='fs-8 text-danger'>15 * 15</span>
                                <span className='fs-8 text-gray-800 ms-2'>Format: </span>
                                <span className='fs-8 text-danger'>.png, .jpg</span>
                                <div className="avatar-upload d-flex align-items-center">
                                    <div className="change position-relative px-0">
                                        <div className="avatar-preview h-125px w-125px border" style={{ borderRadius: '10px' }}>
                                            <img
                                                src={previewUrl || initialImage || default_img}
                                                alt="Category"
                                                className="p-1 h-125px w-125px"
                                            /> 
                                        </div>
                                        <div className="change-btn mt-2 d-flex justify-content-center">
                                            <Button className="btn-xs me-2" variant="success" onClick={() => imageInputRef.current.click()}>
                                                <i className="fa fa-upload" />
                                            </Button>
                                            <Button className="btn-xs" variant="danger" onClick={RemoveImage}>
                                                <i className="fa fa-close" />
                                            </Button>
                                            <input
                                                type="file"
                                                accept=".png, .jpg, .jpeg, .gif"
                                                style={{ display: 'none' }}
                                                ref={imageInputRef}
                                                onChange={fileHandler}
                                            />
                                        </div>
                                        {errors.file && (
                                            <div className="text-danger mt-1 fs-8">{errors.file}</div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                                <Link type="submit" className="btn btn-sm btn-primary" onClick={handleUpdate}>
                                    Update Product Category <i className="fas fa-angle-double-right ms-2"></i>
                                </Link>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default EditProdcat;
